import request  from '@/utils/result'
import md5 from 'md5'
export async function login(name, password) {
  return request('api/user/login', 'post', {
    userAccount: name,
    userPassword: md5(password)
  })
}
export async function wwLogin(code) {
  return request('personapi/workwxlogin', 'post', {},{code})
}
// 获取验证码
export async function getcode(data) {
  return request('api/guestuser/getcode', 'post', {}, {params:data})
}
// 登录
export async function phoneLogin(data) {
  return request('api/guestuser/phonelogon', 'post', {}, {params:data})
}
// 获取验证码
export async function getCaptcha(_params) {
  return request('/api/user/captcha', 'get', _params)
}

